// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Program } from './program';
import { ProgramReviewFinding } from './program-review-finding';
import { ProximityUser } from './proximity-user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramReview extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(64) */
  guidelinesHash!: string;
  /** String */
  guidelinesJson!: string;
  /** String(60) */
  modelId?: string;
  /** Guid FK program */
  programId!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK runByUser */
  runByUserId!: string;
  /** DateTimeOffset */
  runTs!: Date;
  /** String(64) */
  snapshotHash!: string;
  /** String */
  summary?: string;
  /** FK programId */
  program!: Program;
  /** Inv FK programReviewId */
  programReviewFindings!: ProgramReviewFinding[];
  /** FK runByUserId */
  runByUser!: ProximityUser;
}

